/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import { connect } from 'react-redux';
import BookContainer from './BookContainer';
import {sendToPCS, getCollectionById, getPCSLogs, saveCourseInfo, rebuildBook, getBookBuildDetails, sendToEtext, sendToVitalsource, getEtextPublishStatuses, updateProductDetails, updateOfferDetails} from '../../../_thunks/collection.thunk';
import {clearBookBuildStatus, clearCollection, setResourceStatus} from '../../../_actions/collection.actions';
import {saveAccessCode, fetchAccessCodeInfo} from '../../../_thunks/access.code.thunk';
import { updateSubscriptionLength } from '../../../_thunks/vitalsource.thunk';
import {saveBookDetails} from '../../../_thunks/bookdetails.thunk';
import {fetchPdfsByCollectionId} from "../../../_thunks/pdf.links.thunk";
import { saveCourseDetails } from "../../../_thunks/coursedetails.thunk";
import {
    getSchoolDetails,
    getContactDetails,
    getSalesForceDetails,
    getCreatorDetails,
    updateSalesForceOrgUnit,
    saveSelectedSchool,
    searchSchoolByPostalCode
} from "../../../_thunks/order.details.thunk";

function mapStateToProps(state) {
    return {
        bookDetailsActivePage: state.bookDetailsActivePage,
        activeCollection: state.activeCollection,
        isModalOpen: state.modal.isModalOpen,
        pdfLinks: state.pdfLinks,
        router: state.router,
        bookBuildContent: state.bookBuildContent,
        etextStatuses: state.etextStatuses,
        vitalsourceStatuses: state.vitalsourceStatuses,
        pcsLogs: state.pcsLogs,
        collectionNotes: state.collectionNotesReducer.collectionNotes,
        orderDetails : state.orderDetails
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getCollectionFromId: (collId) => {
            dispatch(getCollectionById(collId));
        },
        resetCollection: () => {
            dispatch(clearCollection());
        },
        getPdfsByCollectionId: (collectionId) => {
            dispatch(fetchPdfsByCollectionId(collectionId));
        },
        sendToPCS: (collectionId) => {
            dispatch(sendToPCS(collectionId, false));
        },
        getPCSLogs:(collectionId) => {
            dispatch(getPCSLogs(collectionId));
        },
        getAccessCodeInfo:(collectionId) => {
            dispatch(fetchAccessCodeInfo(collectionId));
        },
        getOrderDetails : (collectionId, creatorId) => {
            dispatch(getSchoolDetails(collectionId));
            dispatch(getContactDetails(collectionId));
            dispatch(getSalesForceDetails());
            dispatch(getCreatorDetails(creatorId));
        },
        saveAccessCodeSetup: (collectionId) => {
            dispatch(saveAccessCode(collectionId));
        },
        saveEtextSetup: (collectionId) => {
            dispatch(saveAccessCode(collectionId));
        },
        saveVitalSourceSetup: (collectionId) => {
            dispatch(updateSubscriptionLength(collectionId));
        },
        saveBookDetailsInfo: (collectionId) => {
            dispatch(saveBookDetails(collectionId));
        },
        rebuildBookSetup: (collectionId) => {
            dispatch(rebuildBook(collectionId));
        },
        publishToEtext: (collectionId, deliveryType) => {
            dispatch(sendToEtext(collectionId, deliveryType));
        },
        publishToVitalsource: (collectionId, deliveryType) => {
            dispatch(sendToVitalsource(collectionId, deliveryType));
        },
        
        getBookBuildContent: (collectionId) => {
            dispatch(getBookBuildDetails(collectionId));
        },
        clearBuildStatus:() => {
            dispatch(clearBookBuildStatus());
        },
        getEtextStatuses: (collectionId) => {
            dispatch(getEtextPublishStatuses(collectionId));
        },
        saveOrderDetails: (collectionId) => {
            dispatch(saveCourseInfo(collectionId));
            dispatch(updateSalesForceOrgUnit(collectionId));
        },
        setResourceStatus: (state) => {
            dispatch(setResourceStatus(state));
        },
        saveCourseDetails: collectionId => {
            dispatch(saveCourseDetails(collectionId));
        },
        updateProductDetails: (collectionId) => {
            dispatch(updateProductDetails(collectionId));
        },
        updateOfferDetails: (collectionId) => {
            dispatch(updateOfferDetails(collectionId));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BookContainer);



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookContainerLink.js